var superhugggMap = {
  account_id: 'accountId',
  claimed: 'claimed',
  claim_method: 'claimMethod',
  claim_restrictions: 'claimRestrictions',
  cover_image_url: 'coverImageUrl',
  created_at: 'createdAt',
  created_by_id: 'createdById',
  expiry: 'expiry',
  huggg_expiry: 'hugggExpiry',
  huggg_expiry_date: 'hugggExpiryDate',
  huggg_tag: 'hugggTag',
  id: 'id',
  is_claimable: 'isClaimable',
  is_expired: 'isExpired',
  launch_url: 'launchUrl',
  limit: 'limit',
  message: 'message',
  order_id: 'orderId',
  per_person: 'perPerson',
  purchase_id: 'purchaseId',
  purchase: 'purchase',
  redeemed_count: 'redeemedCount',
  sender_id: 'senderId',
  sender: 'sender',
  shortcode: 'shortcode',
  title: 'title',
  updated_at: 'updatedAt',
  user_tag: 'userTag'
};
export default superhugggMap;